import React from 'react';
const HighlightedText = ({
  children
}) => <span className="text-emerald-500 font-bold" data-id="element-112">{children}</span>;
export function Header() {
  return <header className="py-12 bg-gradient-to-b from-green-50 to-white rounded-b-lg" data-id="element-113">
      <div className="max-w-4xl mx-auto text-center" data-id="element-114">
        <h1 className="text-3xl md:text-4xl font-bold text-green-900 mb-6 leading-tight" data-id="element-115">
          This US Startup Let's You Legally{' '}
          <HighlightedText data-id="element-116">Microdose Ayahuasca</HighlightedText> For A{' '}
          <HighlightedText data-id="element-117">Calmer</HighlightedText>,{' '}
          <HighlightedText data-id="element-118">Clear</HighlightedText>,{' '}
          <HighlightedText data-id="element-119">Grounded Mind</HighlightedText> - No Tripping Or
          Prescriptions Needed
        </h1>
        <div className="mb-8" data-id="element-120">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fVCyQ9ZmCMYAGF7FFDttk8/ChatGPT_Image_Jun_24%2C_2025%2C_09_49_32_AM.png" alt="Aya Caps bottle with Amazonian vine" className="mx-auto max-w-full h-auto rounded-lg shadow-lg" data-id="element-121" />
        </div>
        <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed" data-id="element-122">
          The effects are subtle—but the shift is real. For many, it's the first
          time they've felt like themselves in years. Read below to learn how
          this breakthrough works.
        </p>
        <div className="flex items-center justify-center mb-4 bg-gray-50 rounded-lg p-3 border border-gray-200" data-id="element-123">
          <div className="flex items-center divide-x divide-gray-300" data-id="element-124">
            <span className="px-3 text-gray-600 font-medium" data-id="element-125">
              2 min read time
            </span>
            <span className="px-3 text-gray-600 font-medium" data-id="element-126">
              Seen by 841,212+
            </span>
            <span className="px-3 text-gray-600 font-medium" data-id="element-127">
              Updated on June 26th 2025
            </span>
          </div>
        </div>
        <div className="flex items-center justify-center mb-10 bg-green-50 rounded-xl p-6 shadow-sm" data-id="element-128">
          <div className="flex-shrink-0 mr-4" data-id="element-129">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i3VSqVo7H7CskmCe2Hkvxq/Screenshot_2025-06-26_at_6.44.56_AM.png" alt="Will Tussy" className="w-24 h-24 rounded-full object-cover border-2 border-green-500" data-id="element-130" />
          </div>
          <div className="text-left" data-id="element-131">
            <h3 className="text-lg font-bold" data-id="element-132">Will Tussy</h3>
            <p className="text-gray-700" data-id="element-133">
              Will Tussy is a writer and dad who turned to microdosing the
              Ayahuasca vine after burnout and anxiety left him feeling
              disconnected. It changed his life—and now he's sharing it with
              others.
            </p>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-134"></div>
      </div>
    </header>;
}